import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Constant } from "../../../../helper/core/constant";
import { CoreService } from "../../../../helper/core/core.service";
import { UserService } from "../../../../helper/core/user.service";
import { TealiumUtagService } from "../../../../tealium/utag.service";
import { EventService } from "../../controller/event.service";
import * as intlTelInput from "intl-tel-input/build/js/intlTelInput";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "app-profil-form",
  templateUrl: "./profil-form.component.html",
  styles: [],
})
export class ProfilFormComponent implements OnInit {
  errorMsg: string = null;
  showAgeField: false;
  requireds: Array<any> = [];
  invite: 1;
  inviteMax: 1;
  onSubmit() { }

  registerLastname: FormControl;
  registerFirstname: FormControl;
  registerEmail: FormControl;
  confirmEmail: FormControl;
  registerTelephone: FormControl;
  registerTelephoneFixe: FormControl;
  registerAge: FormControl;
  registerAdresse: FormControl;
  registerCp: FormControl;
  registerCoutry: FormControl;
  registerVille: FormControl;
  registerCgu: FormControl;
  registerForm: FormGroup;
  public emailsMatch: boolean = true;
  public honeyPot: boolean = false;
  public config: any;
  constructor(
    public EventController: EventService,
    private builder: FormBuilder,
    private coreService: CoreService,
    private constant: Constant,
    private userService: UserService,
    private route: ActivatedRoute,
    private tealium: TealiumUtagService,
  ) { }

  ngOnInit() {

    window.scroll(0, 0);

    $(document).ready(function () {
      const input = document.querySelector("#register-telephone");
      if (input) {
        intlTelInput(input, {
          preferredCountries: [
            "fr",
            "gf",
            "mq",
            "mu",
            "yt",
            "re",
            "gp",
            "bl",
            "sm",
          ],
          separateDialCode: true,
        });
      }
    });

    // Validator du champ nom
    if (this.EventController.event.requiredRegistrationLastname) {
      this.registerLastname = new FormControl("", [
        Validators.required,
        Validators.pattern(this.constant.namePattern),
      ]);
    } else {
      this.registerLastname = new FormControl("", [
        Validators.pattern(this.constant.namePattern),
      ]);
    }
    // Validator du champ prénom
    if (this.EventController.event.requiredRegistrationFirstname) {
      this.registerFirstname = new FormControl("", [
        Validators.required,
        Validators.pattern(this.constant.namePattern),
      ]);
    } else {
      this.registerFirstname = new FormControl("", [
        Validators.pattern(this.constant.namePattern),
      ]);
    }
    // Validator du champ email
    if (this.EventController.event.requiredRegistrationEmail) {
      this.registerEmail = new FormControl("", [
        Validators.required,
        Validators.pattern(this.constant.emailPattern),
      ]);
      this.confirmEmail = new FormControl("", [
        Validators.required,
        Validators.pattern(this.constant.emailPattern),
      ]);
    } else {
      this.registerEmail = new FormControl("", [
        Validators.pattern(this.constant.emailPattern),
      ]);
      this.confirmEmail = new FormControl("", [
        Validators.required,
        Validators.pattern(this.constant.emailPattern),
      ]);
    }
    // Validator du champ téléphone mobile
    if (this.EventController.event.requiredRegistrationPhone) {
      this.registerTelephone = new FormControl("", [
        Validators.required,
        Validators.pattern(this.constant.mobilePattern),
      ]);
    } else {
      this.registerTelephone = new FormControl("", [
        Validators.pattern(this.constant.mobilePattern),
      ]);
    }

    // Validator du champ téléphone fixe
    if (this.EventController.event.requiredRegistrationFixePhone) {
      this.registerTelephoneFixe = new FormControl("", [
        Validators.required,
        Validators.pattern(this.constant.fixePattern),
      ]);
    } else {
      this.registerTelephoneFixe = new FormControl("", [
        Validators.pattern(this.constant.fixePattern),
      ]);
    }

    // Validator du champ adresse
    if (this.EventController.event.requiredRegistrationAddress) {
      this.registerAdresse = new FormControl("", [Validators.required]);
    } else {
      this.registerAdresse = new FormControl("", []);
    }

    // Validator du champ code postale
    if (this.EventController.event.requiredRegistrationPostal_code) {
      this.registerCp = new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5),
        Validators.pattern(this.constant.postalCodePattern),
      ]);
    } else {
      this.registerCp = new FormControl(null, [
        Validators.minLength(5),
        Validators.maxLength(5),
        Validators.pattern(this.constant.postalCodePattern),
      ]);
    }

    // Validator du champs pays !! honeypot !!!!
    this.registerCoutry = new FormControl("", [
      Validators.maxLength(0),
    ]);

    // Validator du champ ville
    if (this.EventController.event.requiredRegistrationCity) {
      this.registerVille = new FormControl("", [Validators.required]);
    } else {
      this.registerVille = new FormControl("", []);
    }

    // Validator du champ CGU
    this.registerCgu = new FormControl("", [Validators.requiredTrue]);

    // Enregistrement du formulaire
    this.registerForm = this.builder.group({
      lastname: this.registerLastname,
      firstname: this.registerFirstname,
      email: this.registerEmail,
      country: this.registerCoutry,
      confirmEmail: this.confirmEmail,
      telephone: this.registerTelephone,
      telephoneFixe: this.registerTelephoneFixe,
      address: this.registerAdresse,
      postalCode: this.registerCp,
      city: this.registerVille,
      notParticipate: false,
      cgu: this.registerCgu,
    });

    if (
      this.EventController.dataForm.dataSlot &&
      this.EventController.dataForm.dataSlot.opts
    ) {
      this.EventController.dataForm.dataSlot.opts.forEach((element) => {
        const controlName: string = "required-" + element.id;

        const controlForm: FormControl = new FormControl(
          null,
          element.required ? [Validators.requiredTrue] : null
        );

        const inputText = element.pdf
          ? '<a href="/' +
          element.pdf +
          "\" target='_blank'>" +
          element.text +
          "</a>"
          : element.text;

        this.requireds = [
          ...this.requireds,
          {
            id: element.id,
            text: element.required ? inputText + " *" : inputText,
          },
        ];
        console.log(this.requireds);
        this.registerForm.setControl(controlName, controlForm);
      });
    }
    console.log('profil form id', this.EventController.event.trackingId);
    let typeEvent =
      this.EventController.event.type == "physical"
        ? "en_physique"
        : "en_ligne";
    this.tealium.view(
      "prise_rdv",
      document.title,
      this.EventController.event.buSlug,
      typeEvent,
      this.EventController.event.trackingId
    );

    this.registerForm.valueChanges.subscribe(() => this.checkEmailsMatch());
  }
  public checkEmailsMatch() {
    this.emailsMatch = this.registerEmail.value === this.confirmEmail.value;
  }

  public createObjectFormForSuscribe() {
    let indicatifPhone = $(".iti__selected-dial-code").text().split("+")[1];
    let obj: any = {
      firstName: this.registerForm.value.firstname,
      lastName: this.registerForm.value.lastname,
      email: this.registerForm.value.email,
      callsign: indicatifPhone,
      phone: this.registerForm.value.telephone,
      fixePhone: this.registerForm.value.telephoneFixe,
      address: this.registerForm.value.address,
      postalCode: this.registerForm.value.postalCode,
      city: this.registerForm.value.city,
      required: "",
      cgu: this.registerForm.value.cgu,
    };

    const requiredVals = {};

    if (!Object.entries) {
      Object.entries = function (obj) {
        const ownProps = Object.keys(obj);
        let i = ownProps.length;
        const resArray = new Array(i);
        while (i--) {
          resArray[i] = [ownProps[i], obj[ownProps[i]]];
        }
        return resArray;
      };
    }
    for (const [key, val] of Object.entries(this.registerForm.value)) {
      if (key.indexOf("required-") !== -1) {
        requiredVals[key.replace("required-", "")] = val;
      }
    }

    obj.required = JSON.stringify(requiredVals);

    return obj;
  }

  /**
   * Envoie les infos utag
   * @param track_zone | string : Nom du tracking
   * @param track_nom | string : Nom du tracking
   * @param track_cible | string : Slug du tracking
   */
  public sendLink(track_zone, track_nom, track_cible = "") {
    this.tealium.link({
      track_zone: this.route.snapshot.paramMap.get("bu") + "_" + track_zone,
      track_nom: track_nom,
      track_cible: window.location.href + "/" + track_cible,
    });
  }

  public async nextStep() {
    if (this.registerForm.valid && this.emailsMatch) {
      let object = this.createObjectFormForSuscribe();
      this.coreService
        .subscribeToEvent(this.EventController.dataForm.chosenDateId, object)
        .subscribe(
          (data) => {
            // On enregistre les informations dans le storage
            // data => {email : xxx, idRegistration : xxx}
            this.userService.setUser(data);

            this.EventController.dataForm = {
              ...this.EventController.dataForm,
              idRegistration: data.idRegistration,
              step: this.EventController.dataForm.step + 1,
              registerForm: this.registerForm,
            };

            this.EventController.dataForm.validStep =
              this.EventController.dataForm.step;

            var slug = this.EventController.event.slug;
            var buSlug = this.EventController.event.buSlug;
            var underscored_slug = slug.replace("-", "_");
            var underscored_buSlug = buSlug.replace("-", "_");
            utag.link({
              type_page: "inscription",
              domaine: "do",
              titre_page:
                underscored_buSlug + "_-_" + underscored_slug + "_-_register",
              track_zone:
                underscored_buSlug + "_-_" + underscored_slug + "_-_confirm",
              track_nom: "inscription_validee",
              track_cible:
                window.location.origin +
                "/" +
                buSlug +
                "/" +
                slug +
                "/" +
                "confirm",
            });
          },
          (dataError) => {
            this.errorMsg = dataError;
          }
        );
    }
  }

  public clickError(): void {
    this.errorMsg = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/profil-form/profil-form.component.ts